import React, { useMemo } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import c from 'classnames';
import { $getSelection } from 'lexical';
import { LggPopover } from 'src/components/general/display/popover';
import { LggEmojiPicker } from 'src/components/pages/conversations/components/contact-interactions/lgg-emoji-picker';
import {
  BasePluginProps,
  PluginIcon,
} from 'src/components/pages/conversations/components/general/lexical-editor/plugins/shared';
import { useVisible } from 'src/hooks/use-visible';

export const EmojiPickerPlugin = ({ disabled = false }: BasePluginProps) => {
  const [editor] = useLexicalComposerContext();
  const { visible: isEmojiPickerVisible, setVisible: setEmojiPickerVisibility } =
    useVisible();

  const insertEmoji = (emoji: string) => {
    editor.focus();

    editor.update(() => {
      const selection = $getSelection();

      if (selection) {
        selection.insertText(emoji);
      }
    });
  };

  const pluginTriggerIcon = useMemo(
    () => (
      <PluginIcon
        type="emoji"
        lggTestId="input-area-emoji-picker-trigger"
        className={c({ active: isEmojiPickerVisible })}
        disabled={disabled}
        onClick={() => {
          if (disabled) {
            return;
          }

          setEmojiPickerVisibility(!isEmojiPickerVisible);
        }}
      />
    ),
    [disabled, isEmojiPickerVisible, setEmojiPickerVisibility],
  );

  if (disabled) {
    return pluginTriggerIcon;
  }

  return (
    <LggPopover
      content={
        <LggEmojiPicker
          onEmojiClick={({ emoji }) => {
            insertEmoji(emoji);
            setEmojiPickerVisibility(false);
          }}
        />
      }
      hideArrow
      destroyTooltipOnHide
      placement="topLeft"
      align={{ offset: [-19, -9] }}
      trigger={['click']}
      visible={isEmojiPickerVisible}
      onVisibleChange={(visible) => {
        setEmojiPickerVisibility(visible);
      }}
    >
      {pluginTriggerIcon}
    </LggPopover>
  );
};
